import {
	disableNotificationInterceptors,
	type FetchConfigurationAnonymousByScopeV2Data,
	type FetchRegistrationCountryCanRegisterByCountryData,
	type FetchUserAgreementVersionActiveByAgreementTypeData,
	type FetchUserAgreementVersionActiveByAgreementTypeParamsAgreementType,
	type PostRegistrationUserData,
	type PostRegistrationUserPayload,
	type PostRegistrationUserValidationEmailCodeData,
	type PostRegistrationUserValidationEmailCodePayload,
	type PostRegistrationUserValidationMobileNumberCodeData,
	type PostRegistrationUserValidationMobileNumberCodePayload,
	type PostRegistrationUserValidationUsernameData,
	type PostRegistrationUserValidationUsernamePayload,
	type PostUserRegistrationEmailGenerateCodeV3Data,
	type PostUserRegistrationEmailGenerateCodeV3Payload,
	type PostUserSendCodeForRegistrationV3Data,
	type PostUserSendCodeForRegistrationV3Payload,
	type PostUserValidationEmailV3Data,
	type PostUserValidationEmailV3Payload
} from '@capsicum/common';

import { configurationApi, registrationApi, userApi } from './index';

import type { MobileNumberAvailability, MobileNumberValidationParams } from '../../models';

export const postValidationUsername = async (
	usernameValidationParams: PostRegistrationUserValidationUsernamePayload
): Promise<Exclude<PostRegistrationUserValidationUsernameData['data'], undefined>> => {
	const api = await registrationApi;
	const response = await api.postRegistrationUserValidationUsername(usernameValidationParams);

	return response.data as Exclude<PostRegistrationUserValidationUsernameData['data'], undefined>; // TODO: validate response
};

export const postRegistrationValidationMobileNumberCode = async (
	validationParams: PostRegistrationUserValidationMobileNumberCodePayload
): Promise<Exclude<PostRegistrationUserValidationMobileNumberCodeData['data'], undefined>> => {
	const api = await registrationApi;

	const response = await api.postRegistrationUserValidationMobileNumberCode(validationParams, {
		customErrorInterceptor: disableNotificationInterceptors
	});

	return response.data as Exclude<PostRegistrationUserValidationMobileNumberCodeData['data'], undefined>; // TODO: validate response
};

export const postRegistrationValidationEmailCode = async (
	validationParams: PostRegistrationUserValidationEmailCodePayload
): Promise<Exclude<PostRegistrationUserValidationEmailCodeData['data'], undefined>> => {
	const api = await registrationApi;

	const response = await api.postRegistrationUserValidationEmailCode(validationParams, {
		customErrorInterceptor: disableNotificationInterceptors
	});

	return response.data as Exclude<PostRegistrationUserValidationEmailCodeData['data'], undefined>; // TODO: validate response
};

export const postValidationMobileNumber = async (
	mobileNumberValidationParams: MobileNumberValidationParams
): Promise<MobileNumberAvailability> => {
	const api = await registrationApi;

	const response = await api.postUserValidationMobileNumberV3(mobileNumberValidationParams, {
		customErrorInterceptor: disableNotificationInterceptors
	});

	return response.data as MobileNumberAvailability; // TODO: validate response
};

export const postValidationEmail = async (
	emailValidationParams: PostUserValidationEmailV3Payload
): Promise<Exclude<PostUserValidationEmailV3Data['data'], undefined>> => {
	const api = await registrationApi;
	const response = await api.postUserValidationEmailV3(emailValidationParams);

	return response.data as Exclude<PostUserValidationEmailV3Data['data'], undefined>; // TODO: validate response
};

export const fetchCountryCanRegister = async (
	country: string
): Promise<Exclude<FetchRegistrationCountryCanRegisterByCountryData['data'], undefined>> => {
	const api = await registrationApi;
	const response = await api.fetchRegistrationCountryCanRegisterByCountry(country);

	return response.data as Exclude<FetchRegistrationCountryCanRegisterByCountryData['data'], undefined>; // TODO: validate response
};

export const fetchAgreementVersionActive = async (
	agreementType: FetchUserAgreementVersionActiveByAgreementTypeParamsAgreementType
): Promise<Exclude<FetchUserAgreementVersionActiveByAgreementTypeData['data'], undefined>> => {
	const api = await userApi;
	const response = await api.fetchUserAgreementVersionActiveByAgreementType({
		agreementType,
		'details[]': ['agreementVersionTranslations']
	});

	return response.data as Exclude<FetchUserAgreementVersionActiveByAgreementTypeData['data'], undefined>; // TODO: validate response
};

export const fetchConfigurationAnonymous = async (
	locale: string
): Promise<Exclude<FetchConfigurationAnonymousByScopeV2Data['data'], undefined>> => {
	const api = await configurationApi;
	const response = await api.fetchConfigurationAnonymousByScopeV2({
		locale: locale,
		scope: 'frontend'
	});

	return response.data as Exclude<FetchConfigurationAnonymousByScopeV2Data['data'], undefined>; // TODO: validate response
};

export const postSendSMSCodeForRegistration = async (
	mobileNumberValidationParams: PostUserSendCodeForRegistrationV3Payload
): Promise<Exclude<PostUserSendCodeForRegistrationV3Data['data'], undefined>> => {
	const api = await registrationApi;
	const response = await api.postUserSendCodeForRegistrationV3(mobileNumberValidationParams);

	return response.data as Exclude<PostUserSendCodeForRegistrationV3Data['data'], undefined>; // TODO: validate response
};

export const postSendEmailCodeForRegistration = async (
	emailValidationParams: PostUserRegistrationEmailGenerateCodeV3Payload
): Promise<Exclude<PostUserRegistrationEmailGenerateCodeV3Data['data'], undefined>> => {
	const api = await registrationApi;
	const response = await api.postUserRegistrationEmailGenerateCodeV3(emailValidationParams);

	return response.data as Exclude<PostUserRegistrationEmailGenerateCodeV3Data['data'], undefined>; // TODO: validate response
};

export const postRegistration = async (
	userRegisterParams: PostRegistrationUserPayload
): Promise<Exclude<PostRegistrationUserData['data'], undefined>> => {
	const api = await registrationApi;
	const response = await api.postRegistrationUser(userRegisterParams);

	return response.data as Exclude<PostRegistrationUserData['data'], undefined>; // TODO: validate response
};
